import React from "react";

export default function Admin() {
  return <h2>Admin Page Working!</h2>;
}
